// frontend/teaweb-frontend/src/api.js
// Compute API base dynamically from environment and origin.

const getApiBase = () => {
	if (
		typeof process !== 'undefined' &&
		process.env &&
		process.env.REACT_APP_API_BASE
	) {
		return process.env.REACT_APP_API_BASE.replace(/\/$/, '');
	}

	const hostname = window.location.hostname;
	const origin = window.location.origin;

	// Local development detection
	if (hostname === 'localhost' || hostname === '127.0.0.1') {
		// If running under a subpath /TeaWeb or standard local Apache setup
		return `${origin}/TeaWeb/backend/api`;
	}

	// Production cPanel hosting (e.g. ceymoslanka.com)
	// Backend is located directly at /backend/api under public_html
	return `${origin}/backend/api`;
};

export const API_BASE = getApiBase();

// Standard uploads directory URL
export const UPLOADS_BASE = `${API_BASE.replace(/\/api$/, '')}/uploads`;

// Helper to get image upload URL with fallback
export const getUploadUrl = (category, imageName) => {
	if (!imageName) return '';
	if (imageName.startsWith('http://') || imageName.startsWith('https://') || imageName.startsWith('data:')) {
		return imageName;
	}
	return `${UPLOADS_BASE}/${category}/${imageName}`;
};

export default API_BASE;
